<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size lg_size">
                <a href="javascript:" class="ui_close" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                <dl class="modal_content">
                    <dt class="ellipsis maintit">
                        <i>User</i>
                    </dt>
                    <dd>
                    <div class="view_cont">
                        <table class="data_table">
                            <colgroup>
                                <col width="*" />
                                <col width="*" />
                                <col width="*" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>{{ this.popupType }}</th>
                                    <th>View</th>
                                    <th>User</th>
                                </tr>
                            </thead>
                            <tbody class="text_center">
                                <tr v-for="(data, index) in tableData" :key="index">
                                    <td align='left'>{{ data.NAME }}</td>
                                    <td>{{ data.CNT }}</td>
                                    <td>{{ data.USER_CNT }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="btn_wrap topLine">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_white" @click="$emit('close')">{{
                                    $t('BUTTON.GLOBAL.CLOSE')
                                }}</a>
                            </div>
                        </div>
                    </div>
                </dd>
                </dl>

            </div>
        </div>
    </div>
</template>

<script>
import Vue                  from 'vue';
import axios                from 'axios';
import qs                   from 'query-string';
import $                    from 'jquery';
import store                from '@/vuex/store';
import SDLUtil              from '@/utils/SDLUtil';
import { EventBus }         from '@/utils/EventBus';
import ToastGrid            from '~c/ToastGrid';

export default {
    name: 'searchUserPop',
    components: {
        'toast-grid': ToastGrid,
    },

    props : ['popupType', 'keyNo', 'subsidiaryCd' , 'searchFormDate' , 'searchToDate'],
    data() {
        return {
            pageName: 'unreadPop',
            loginId: '',
            loginNo: '',
            loginNm: '',
            tableData: [],
        };
    },
    created() {
        
    },

    mounted() {
        this.onSearch();
    },
    methods: {
        async onSearch() {
            
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/statisticsManager/statisticsManagerUsagePopup.skp`,
                    qs.stringify({
                        POPUP_TYPE       : this.popupType, 
                        KEY_NO           : this.keyNo, 
                        SUBSIDIARY_CD    : this.subsidiaryCd, 
                        SEARCH_FROM_DATE : this.searchFormDate, 
                        SEARCH_TO_DATE   : this.searchToDate,
                    }),
                )
                .then(resp => {
                    this.tableData = resp.data.result;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/UsagePopVue.vue